import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { getRequest } from 'src/utils/request';

interface DispoTimeWindowRawType {
  id: string;
  attributes: {
    starts_at: string | null;
    ends_at: string | null;
    applications_count: number;
  };
}

export interface DispoTimeWindowType {
  id: string;
  startsAt: string | null;
  endsAt: string | null;
  applicationsCount: number;
}

const getDispoTimeWindows = async (
  jobUuid: string,
  shiftDate: string,
): Promise<DispoTimeWindowType[]> => {
  const { data } = await getRequest<{ data: DispoTimeWindowRawType[] }>(
    API.GET.getDispoTimeWindows(jobUuid, shiftDate),
  );

  return data.data.map(({ id, attributes }) => ({
    id,
    startsAt: attributes.starts_at,
    endsAt: attributes.ends_at,
    applicationsCount: attributes.applications_count,
  }));
};

export const useGetDispoTimeWindows = ({
  jobUuid,
  shiftDate,
  enabled = true,
}: {
  jobUuid: string;
  shiftDate: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: [
      QUERY_KEYS.JOB_APPLICATIONS,
      QUERY_KEYS.DISPO_TIME_WINDOWS,
      jobUuid,
      shiftDate,
    ],
    queryFn: () => getDispoTimeWindows(jobUuid, shiftDate),
    staleTime: 1000 * 60,
    enabled,
  });
};
